import { Button, Modal, Form, Input, Upload, message, InputNumber } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { MyValidateMessages } from '../../../../utils/validateMessaage'
import './newModal.css'
import { newBanner } from '../../../../api/api'
import UploadOnePicture from '../../../../components/upLoadOnePicture/uploadPicture'

export default function NewModal(props) {
  //表单设置
  const { TextArea } = Input
  const [componentDisabled, setComponentDisabled] = useState(false)
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled)
  }
  const [form] = Form.useForm()
  const [total, setTotal] = useState(props.total)

  //modal设置
  const [open, setOpen] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const showModal = () => {
    setOpen(true)
  }

  const setIsfresh = props.setIsFresh //刷新组件

  const handleOk = (e) => {
    form.setFieldValue('image', url)
    form.validateFields().then((res) => {
      // const params = Object.assign(res, { position: total + 1 })
      newBanner(res).then((res) => {
        console.log(res)
        setIsfresh((pre) => {
          return !pre
        })
        setTotal(total + 1)
        message.success('新建轮播图成功！')
        form.resetFields() 
        setOpen(false)
      })
    })
  }

  const handleCancel = () => {
    console.log('Clicked cancel button')
    setOpen(false)
  }

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (url) => {
    setUrl(url)
    // console.log(url);
  }

  return (
    <>
      <Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
        新建
      </Button>
      <Modal
        title="新建轮播图"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
        >
          <Form.Item
            label="轮播图名称"
            name="title"
            rules={[
              {
                required: true,
                max: 10,
              },
            ]}
          >
            <Input placeholder="上限10字" />
          </Form.Item>

          <Form.Item
            label="轮播图顺序"
            name="position"
            rules={[
              {
                type: 'number',
                required: true,
                max: 5,
                min: 1,
              },
            ]}
          >
            <InputNumber
              style={{ width: '18vw' }}
              placeholder="请输入1-5的数字"
            />
          </Form.Item>

          <Form.Item label="轮播图URL" name="redirect">
            <TextArea
              rows={4}
              placeholder="请输入需要跳转的小程序页面URL或公众号文章链接"
            />
          </Form.Item>

          <Form.Item
            label="轮播图图片"
            valuePropName="image"
            name="image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setImgUrl} image={null ?? ''} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
